import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_leads-brands_form_mobile_navigation_second_next-click';
/**
 * Click on next in the second page of the mobile brands sign up form
 */
export function trackBrandLeadsBrandsFormMobileNavigationSecondNextClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
    });
}
